import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

/**
 *
 * @param {String} title -- SVGs use "title" sub-element for tooltip and accessibility.
 * It explain the content of the image. EG: "Submission Confirmed" for icon used after form submission.
 * This is similar to the way that IMG elements use the "alt" attribute
 * https://developer.mozilla.org/en-US/docs/Web/SVG/Element/title
 * @param {number} height --  Icon sizing is controlled via font-size css or height prop.
 * @returns {JSX.Element}
 * @constructor
 */
// eslint-disable-next-line no-unused-vars
const BaseSVG = ({ height, title, ...props }) => (
    <svg {...props}>
        {title ? <title>{title}</title> : null}
        {props.children}
    </svg>
);

/*
 * This equates to a 40x40 square SVG icon.
 *
 * Adjust the em values to simulate the aspect ratio of your icon based on the
 * viewBox width & height values (values 3 and 4, respectively in "0 0 0 0").
 *
 * if you need to resize the icon in a media query, just change the font-size,
 * which effectively maps to "height" and the icon will resize itself without
 * distorting the aspect ratio.
 */
const Icon = styled(BaseSVG)`
    display: inline-block;
    font-size: ${(p) => (p.height ? `${p.height}px` : '1em')};
    height: 1em;
    width: 1em;
`;

Icon.propTypes = {
    height: PropTypes.number,
};

export { Icon as default, Icon };
